import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {FormDefinitionFieldRepository} from './impl/service/ngrx/formDefinitionField.repository';
import {FormDefinitionFieldConverter} from './api/entity/converter/formDefinitionField.converter';
import {FormDefinitionFieldSummaryConverter} from './api/entity/converter/formDefinitionFieldSummary.converter';
import {FormDefinitionFieldDataService} from './impl/service/ngrx/formDefinitionFieldData.service';
import {FormDefinitionFieldSummaryDataServiceAdapter} from './impl/service/ngrx/formDefinitionFieldSummaryDataService.adapter';
import {FormDefinitionFieldDataServiceAdapter} from './impl/service/ngrx/formDefinitionFieldDataService.adapter';
import {FormDefinitionFieldFindAllCachedService} from './impl/service/formDefinitionFieldFindAllCached.service';
import {FormDefinitionFieldFindAllService} from './impl/service/formDefinitionFieldFindAll.service';
import {
    ReportComponentLabelDefaultValueLeftRightRowsJsonHandlerComponent
} from './impl/component/json-handler/report-component-label-default-value-left-right-rows-json-handler/report-component-label-default-value-left-right-rows-json-handler.component';
import {
    ReportComponentLabelDefaultValueLeftRightRowsJsonHandlerModule
} from './impl/component/json-handler/report-component-label-default-value-left-right-rows-json-handler/report-component-label-default-value-left-right-rows-json-handler.module';
import {
    FieldInputTypeHandlerRegister
} from '../../../../components/common/field/field-input/type-handler/IFieldInputTypeHandler';
import {FormDefinitionFieldType} from './api/entity/formDefinitionFieldSummary.model';
import {
    ReportComponentLabelDefaultValueValueRowsJsonHandlerModule
} from './impl/component/json-handler/report-component-label-default-value-value-rows-json-handler/report-component-label-default-value-value-rows-json-handler.module';
import {
    ReportComponentLabelDefaultValueValueRowsJsonHandlerComponent
} from './impl/component/json-handler/report-component-label-default-value-value-rows-json-handler/report-component-label-default-value-value-rows-json-handler.component';

@NgModule({
    providers: [
        FormDefinitionFieldDataService,
        FormDefinitionFieldRepository,
        FormDefinitionFieldSummaryDataServiceAdapter,
        FormDefinitionFieldDataServiceAdapter,
        FormDefinitionFieldConverter,
        FormDefinitionFieldSummaryConverter,
    ],
    imports: [
        ReportComponentLabelDefaultValueLeftRightRowsJsonHandlerModule,
        ReportComponentLabelDefaultValueValueRowsJsonHandlerModule,
    ]
})
export class FormDefinitionFieldModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: FormDefinitionFieldDataService,
                repository: FormDefinitionFieldRepository,
    ) {

        entityDataService.registerServices({
            FormDefinitionField: dataService,
        });

        entityServices.registerEntityCollectionServices({
            FormDefinitionField: repository,
        });


        FieldInputTypeHandlerRegister.register(ReportComponentLabelDefaultValueLeftRightRowsJsonHandlerComponent,
            FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_JSON,
            'FORM_DEFINITION_FIELD_SUBTYPE_REPORT_COMPONENT_EXAM_DEFAULT_LEFT_RIGHT_VALUE_ROW');
        FieldInputTypeHandlerRegister.register(ReportComponentLabelDefaultValueValueRowsJsonHandlerComponent,
            FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_JSON,
            'FORM_DEFINITION_FIELD_SUBTYPE_REPORT_COMPONENT_EXAM_LABEL_DEFAULT_VALUE_VALUE_ROW');
    }
}
